import reducer from './sequences';
import { actionCreators, SequencesActionType } from './sequences.actionCreators';
import * as actionTypes from './sequences.actionTypes';

export * from './sequences'; // expose all types
export * from './sequences.selectors';
export type ActionType = SequencesActionType;
export { actionTypes, actionCreators };
export default reducer;
